/**
 * SelectionTile composite — public API for the package.
 * Re-export the component and its props type for consumers.
 */
export { SelectionTile, type SelectionTileProps } from './SelectionTile';
